import React, { Component } from "react";

import Icon from "./../../../shared/items/static/icon";
import Input from "./../../../shared/items/contols/input";

import styles from "./searchCarsString.module.scss";
import { withRoutes } from "../../../shared/containers/containerRoutes";

class SearchRoutesString extends Component {
  componentDidMount() {
    const { onChangeSearchTerm } = this.props;
    onChangeSearchTerm("");
  }

  handleChangeStore(name, value) {
    const { onChangeSearchTerm, requestOptions, onGetRoutes } = this.props;
    onChangeSearchTerm(value);

    const options = Object.assign({}, requestOptions, {
      searchTerm: value,
    });

    onGetRoutes(options);
  }

  render() {
    return (
      <div className={styles.searchCars}>
        <Input name="searchTerm" type="text" handleChangeStore={this.handleChangeStore.bind(this)} placeholder="Поиск" />
        <div className={styles.container_searchBtn}>
          <Icon name="search" />
        </div>
      </div>
    );
  }
}

export default withRoutes(React.memo(SearchRoutesString));
